import React, { Component } from 'react';
import request from "@/method/request";
import { Input, Button, DatePicker, message } from 'antd';
import moment from "moment";
import "./index.scss";

const { TextArea } = Input;
const { MonthPicker } = DatePicker;

class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        loadingSave: false,
        data: { content: "" },
    }

    componentDidMount() {
        this.getData(this.state.date)
    }


    async getData(date) {
        try {
            const month = moment(date).format('M');
            const year = moment(date).format('YYYY');

            const x = await request(`/t4_1_note?year=${year}&month=${month}`);

            this.setState({ data: x.data || {} });

        } catch (err) {
            console.error(err);
        }
    }
    onSave = async () => {
        try {
            this.setState({ loadingSave: true });
            let { date, data } = this.state;
            if (!date) {
                message.error('请选择年份月份');
                let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
                return
            }

            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            data = { ...data, year, month };

            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }

            const x = await request('/t4_1_noteAdd', headres);
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data.id) {
                    this.getData(date);
                }
                return
            }
            message.error(x.msg);
        } catch (err) {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        }
    }
    render() {
        const { loadingSave, data, date } = this.state;
        const { email = "" } = JSON.parse(sessionStorage.getItem('user') || "{}");
        return (

            <div className="t4_1_4_note">
                <div className="title">备注</div>
                <MonthPicker
                    placeholder="请选择年月"
                    monthCellContentRender={(date, local) => {
                        return moment(date).format('M月')
                    }}
                    defaultValue={moment(date, "YYYY-MM")}
                    format="YYYY-MM"
                    onChange={(date, str) => {
                        this.setState({
                            date: str,
                            data: { content: "" },
                        });
                        this.getData(str)
                    }}
                />
                <TextArea
                    value={data.content}
                    rows={4}
                    onChange={e => this.setState({ data: { ...data, content: e.target.value || "" } })}
                />
                <div className="btn">
                    <Button
                        type="primary"
                        onClick={this.onSave}
                        loading={loadingSave}
                    >保存</Button>
                </div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/note/index.js